import * as React from 'react'
import {IPopupDispatcher} from '../../core/interfaces/dispatchers'
import {getMapService} from '../../core/reducers/map'
import appConfig from '../../reducers/appConfig'

interface Props {
  left: string
  popupDispatcher: IPopupDispatcher
  handleIsLabelMovingButtonStateOnClick: () => void
  isLabelMovingButtonActive: boolean
}

export const LabelMovingTool: React.FC<Props> = ({
  left,
  handleIsLabelMovingButtonStateOnClick,
  isLabelMovingButtonActive
}) => {
  React.useEffect(() => {
    if (!isLabelMovingButtonActive) return
    const mapService = getMapService()
    if (mapService?.drawing) {
      mapService.drawing.activateLabelMoving([appConfig.reg.parcels.parcelsUrl, appConfig.reg.quarters.quartersUrl])
    }
  }, [isLabelMovingButtonActive])

  return (
    <div
      className="measure-tool"
      style={{left}}
      title="Местене на текст"
      onClick={handleIsLabelMovingButtonStateOnClick}
    >
      <img
        alt=""
        src="resources/icons/labelm.png"
        style={{width: '28px', height: '28px', backgroundColor: isLabelMovingButtonActive ? '#26751b' : '#5c83b3b5'}}
      />
    </div>
  )
}
